<ng-container [ngSwitch]="skeletonRoute$ | async">
  <ng-container *ngSwitchCase="'identification'">
    <ng-container *ngTemplateOutlet="identificationSkeleton"></ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="'journey-selection'">
    <ng-container *ngTemplateOutlet="journeySelectionSkeleton"></ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="'overview'">
    <ng-container *ngTemplateOutlet="overview"></ng-container>
  </ng-container>
</ng-container>

<ng-template #identificationSkeleton>
  <refx-basic-layout>
    <div class="page-wrapper" mainContent>
      <div class="form-identification-card">
        <ngx-skeleton-loader
          appearance="line"
          class="identification-title-skeleton">
        </ngx-skeleton-loader>
        <refx-identification-skeleton-pres
          [displayTermsAndConditions]="true">
        </refx-identification-skeleton-pres>
        <ngx-skeleton-loader
          appearance="line"
          class="back-home-button">
        </ngx-skeleton-loader>
      </div>
    </div>
  </refx-basic-layout>
</ng-template>

<ng-template #journeySelectionSkeleton>
  <refx-basic-layout>
    <div class="page-wrapper" mainContent>
      <div class="journey-selection-skeleton">
        <refx-page-title-skeleton-pres pageHeader
          [displaySubtitleSkeleton]="false">
        </refx-page-title-skeleton-pres>
        <refx-journey-selection-skeleton>
        </refx-journey-selection-skeleton>
        <ngx-skeleton-loader
          appearance="line"
          class="exit-button">
        </ngx-skeleton-loader>
      </div>
    </div>
  </refx-basic-layout>
</ng-template>

<ng-template #overview>
  <refx-basic-layout>
    <div class="page-wrapper" mainContent>
      <div class="overview-skeleton">
        <refx-page-title-skeleton-pres pageHeader
          [displaySubtitleSkeleton]="true">
        </refx-page-title-skeleton-pres>
        <refx-timing-recap-skeleton class="timing-recap-skeleton">
        </refx-timing-recap-skeleton>
        <refx-journey-selection-skeleton>
        </refx-journey-selection-skeleton>
        <refx-passenger-recap-skeleton-pres [titlePosition]="'left'">
        </refx-passenger-recap-skeleton-pres>
        <refx-navigation-menu-skeleton>
        </refx-navigation-menu-skeleton>
        <ngx-skeleton-loader
          appearance="line"
          class="back-home-button">
        </ngx-skeleton-loader>
      </div>
    </div>
  </refx-basic-layout>
</ng-template>
